"use strict";
import { DEFAULT_OG_IMAGE } from "constants/meta";
import { Helmet } from "react-helmet-async/lib/index";
import { useLocation } from "react-router-dom";
import { getStaticRouteMeta } from "shared-cloud/routeMeta";
import { useSporeColors } from "ui/src";
import { getCanonicalUrl } from "utils/urlRoutes";
export default function MetaData() {
  const location = useLocation();
  const { pathname } = location;
  const { title, description } = getStaticRouteMeta(pathname);
  const canonicalUrl = getCanonicalUrl(pathname);
  const colors = useSporeColors();
  return <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {
    /* Open Graph / Facebook */
  }
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Topaz Dex" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:url" content={canonicalUrl} />
      {
    /* Twitter */
  }
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@TopazDex" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      <link href="https://fonts.gstatic.com" rel="preconnect" crossOrigin="" />
      <meta name="robots" content="max-image-preview:large" />
      <style>{`
            html {
              ::-webkit-scrollbar-thumb {
                background-color: ${colors.surface3.val};
              }
              scrollbar-color: ${colors.surface3.val} ${colors.surface1.val};
            }
          `}</style>
    </Helmet>;
}
